import React from 'react';
import SignContainer from './container';

const Sign = () => {
    return <SignContainer />;
};

export default Sign;
